import { IEventCollectionData } from 'meta/pages/v4/eventCollection'
import { ApiEndpoint } from 'controller/endpoint'
import { HttpRequestForApiV4 } from 'utils/http'

type Props = {
  collectionId: string
}

type Response = IEventCollectionData

export const getData = async (props: Props): Promise<Response> => {
  const { collectionId } = props

  const endpoint = ApiEndpoint.v4.eventCollection.data(collectionId)

  const { data } = await HttpRequestForApiV4.get<Response>(endpoint)
  return data
}
